<div class="fix-action-row">
  <h1 matDialogTitle>{{data.userDisplayName}}'s {{data.applicationCode}} {{data.menuKey}} Menu Preview</h1>
  <mat-dialog-content>
    <optsol-ngx-side-menu *ngIf="menuData" [data]="menuData" [compactView]="true" [collapsedOnStartup]="true">
    </optsol-ngx-side-menu>
  </mat-dialog-content>
  <div class="spacer"></div>
  <mat-dialog-actions>
    <button mat-button matDialogClose>Close</button>
  </mat-dialog-actions>
</div>